var map = {
	"./banner.jpg": "21d9",
	"./bg-case.png": "16bd",
	"./icon-adv-1.png": "b017",
	"./icon-adv-2.png": "efc0",
	"./icon-adv-3.png": "b3d8",
	"./icon-adv-4.png": "02ec",
	"./icon-scene-1.png": "f759",
	"./icon-scene-2.png": "58bb",
	"./icon-scene-3.png": "a1c4",
	"./icon-scene-4.png": "4678",
	"./icon-scene-5.png": "8cce",
	"./icon-scene-6.png": "eb56",
	"./img-fun-1.png": "e3c5",
	"./img-fun-2.png": "45f0",
	"./img-fun-3.png": "42c4",
	"./img-fun-4.png": "fc14"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f512";